// Force quick add buttons altijd zichtbaar
function forceQuickAddVisible() {
  const quickAddButtons = document.querySelectorAll('.quick-add-button, .product-card__quick-add, .quick-buy-button');
  quickAddButtons.forEach(button => {
    button.style.opacity = '1';
    button.style.visibility = 'visible';
  });
}

// Run bij page load
document.addEventListener('DOMContentLoaded', forceQuickAddVisible);

// Run ook tijdens scroll
window.addEventListener('scroll', forceQuickAddVisible);

// Observer voor dynamisch geladen content
const observer = new MutationObserver(forceQuickAddVisible);
observer.observe(document.body, { childList: true, subtree: true });
